// extracted by mini-css-extract-plugin
module.exports = {"simpleDetailsSection":"SimpleDetailsSection_simpleDetailsSection__1rSg2","text":"SimpleDetailsSection_text__gXEaF"};